export default __webpack_public_path__ + "static/media/points.8e9cadd8.svg";